import React from 'react'
import { ErrorBoundary, FallbackProps } from 'react-error-boundary'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { isFeatureAccessDenied } from '../../utils/isFeatureAccessDenied'

import { AccessDenied } from 'components/AccessDenied/AccessDenied'

interface ResidentAppErrorBoundaryProps {
  fallbackRender: (props: FallbackProps) => React.ReactNode
  children: React.ReactNode
}

export const ResidentAppErrorBoundary: React.FC<
  ResidentAppErrorBoundaryProps
> = ({ fallbackRender, children }) => {
  const { t } = useTranslation(['errors'])
  const location = useLocation()

  const renderAccessDeniedOrFallback = (props: FallbackProps) =>
    isFeatureAccessDenied(props.error) ? (
      <AccessDenied
        message={t('errors:other.featureAccessDenied')}
        resetErrorBoundary={props.resetErrorBoundary}
      />
    ) : (
      fallbackRender(props)
    )

  return (
    <ErrorBoundary
      fallbackRender={renderAccessDeniedOrFallback}
      resetKeys={[location.pathname]}
    >
      {children}
    </ErrorBoundary>
  )
}
